import React, { Fragment, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Form, Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import { v4 as uuidv4 } from 'uuid'
import {
  AdjustIcon,
  SpinWrapper,
} from 'modules/Onboarding/Register/Education/style'
import ExperienceForm from 'modules/Onboarding/Register/ProjectInternshipNew/Project'
import {
  ButtonLocal,
  Text,
} from 'modules/Onboarding/Register/WorkExperience/style'
import { SubHeading1 } from 'modules/Resume/DrawerComponents/EducationDetailStyle'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { searchConfig } from 'utils/config'
import moment from 'moment'

const WorkExperience = ({
  setCurrent,
  studentData,
  studentFormData,
  updateStudentData,
  getListOfSkills,
  activeKey,
  cvDetails,
  searchAPI,
  getCorporateList,
  getDesignationsList,
  getFunctionsList,
  getIndustryList,
  setActiveTab,
  setModalVisibleData,
  registerForm,
  pendingData,
  updateCurrentState,
  getStudentData,
}) => {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  
  // Register this form with the parent component for stepper validation
  useEffect(() => {
    if (typeof registerForm === 'function') {
      registerForm('work', form);
      
      // Cleanup when component unmounts
      return () => registerForm('work', null);
    }
  }, [form, registerForm])

  const [experience, setExperience] = useState([])
  const [isPresent, setIsPresent] = useState(false)
  const [corporateName, setCorporateName] = useState([])
  const [corporateId, setCorporateId] = useState('')
  const [skillLoading, setSkillLoading] = useState(true)
  const [loading, setLoading] = useState(true)
  const [isCvTrue, setIsCvTrue] = useState(false)
  const [allSkills, setAllSkills] = useState([])
  const [submitLoading, setSubmitLoading] = useState(false)
  const [isExpUpdated, setIsExpUpdated] = useState(false)
  const [updated, setUpdated] = useState(false)
  const [shown, setShown] = useState([]);
  const[listOfAddedSkills,setListOfAddedSkills] = useState([])

    const SkillsAPI = async search => {
      try {
        const results = await searchAPI(
          searchConfig?.skills?.name,
          search,
          searchConfig?.skills
        )
        let updatedSkills = results || [];
        const newSkill = {
          name: search,
          id: Math.random().toString(36).substr(2, 8),
        };
  
      if (updatedSkills.length === 0 && search) {
        setListOfAddedSkills(prev => [...prev, newSkill]);
        updatedSkills = [newSkill, ...updatedSkills];
      }

      const isExactMatch = updatedSkills.some(skill => skill?.name.toLowerCase() === search?.toLowerCase());
      if(updatedSkills.length > 0 ){
        if(!isExactMatch && search?.length > 3){ 
          setListOfAddedSkills(prev => [...prev, newSkill]);
          updatedSkills = [newSkill, ...updatedSkills];
        } else {
          updatedSkills = updatedSkills
        }
      }
  
        if (!allSkills?.length) {
          setAllSkills(updatedSkills)
        }
        setSkillLoading(false)
        return updatedSkills
      } catch (error) {
        setSkillLoading(false)
  
        console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
      }
    }
  useEffect(() => {
    SkillsAPI()
  }, [])

  useEffect(() => {
    let experienceList = []
    let studentCvResume = cvDetails
    
    const pendingWorkExp = pendingData?.resume?.workExperience || []
    
    // Only use CV data if there's no actual data AND no pending data
    let studentWorkExperienceDetails = studentFormData?.resume?.workExperience
      ?.length
      ? studentFormData?.resume?.workExperience
      : (pendingWorkExp?.length ? [] : studentCvResume?.workExperience || [])
    
    // Use pendingMap pattern for work experience
    if (pendingWorkExp.length > 0) {
      const pendingMap = new Map()
      pendingWorkExp.forEach(pendingItem => {
        if (pendingItem.id && !pendingItem.id.startsWith('temp-')) {
          pendingMap.set(pendingItem.id, pendingItem)
        }
      })
      
      studentWorkExperienceDetails = studentWorkExperienceDetails.map(approvedItem => {
        const pendingItem = pendingMap.get(approvedItem.id)
        
        if (pendingItem && pendingItem._pendingFields) {
          const merged = { ...approvedItem }
          
          Object.keys(pendingItem._pendingFields).forEach(fieldName => {
            merged[fieldName] = pendingItem._pendingFields[fieldName].value
          })
          
          merged._hasPendingChanges = true
          merged._pendingFields = pendingItem._pendingFields
          
          return merged
        }
        
        return approvedItem
      })
      
      const newPendingWorkExp = pendingWorkExp.filter(
        item => !item.id || item.id.startsWith('temp-') || item._isNew
      )
      studentWorkExperienceDetails = [...studentWorkExperienceDetails, ...newPendingWorkExp]
    }

    if (
      studentFormData?.resume?.workExperience?.length <
        studentCvResume?.workExperience?.length &&
      !isCvTrue
    ) {
      setIsCvTrue(true)
    }
    studentWorkExperienceDetails?.map((data, index) => {
      if (data?.isCurrentlyWorking === true) {
        setIsPresent(true)
      }
      let formName = 'experience_' + index
      const formattedDescription = Array.isArray(data?.description)
        ? data.description.map(item => `${item}`).join('\n')
        : data?.description
      form.setFieldsValue({
        [formName]: {
          corporateId: data?.corporateId,
          organization: data?.organization,
          title: data?.title,
          started_in: moment(data?.started_in, 'MM/YYYY').isValid() ? data?.started_in : null,
          ended_in: moment(data?.ended_in, 'MM/YYYY').isValid() ? data?.ended_in : null,
          function: data?.function,
          role: data?.role,
          industry: data?.industry,
          description: formattedDescription,
          skill_set: data?.skill_set,
          certificate: data?.certificate && (data?.certificate?.size || data?.certificate?.url) ? data?.certificate : null,
          awards: data?.awards,
          noticePeriod: data?.noticePeriod,
          isCurrentlyWorking: data?.isCurrentlyWorking,
          jobType: data?.jobType,
          isDelete: false,
        },
      })

      return experienceList.push({
        component: ExperienceForm,
        formName: formName,
      })
    })
    setExperience(experienceList)
    
    setLoading(false)
  }, [studentFormData])
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const experienceHandler = (isAdd, isDelete, deleteForm) => {
    const experienceKeys = Object.keys(form.getFieldValue())

    let lastValue = 0
    for (let i = experienceKeys.length - 1; i >= 0; i--) {
      const key = experienceKeys[i]
      const intValue = parseInt(key.split('_')[1])
      if (!isNaN(intValue)) {
        lastValue = intValue
        break
      }
    }
    let arr = []
    let formName = 'experience_' + `${lastValue + 1}`
    arr.push({
      component: ExperienceForm,
      formName: formName,
    })
    if (isAdd) {
      setExperience(exp => exp.concat(arr))
    }
    if (isDelete) {
      let formDataCurrent = form.getFieldValue(deleteForm)
      if (formDataCurrent?.isCurrentlyWorking === true) {
        setIsPresent(false)
      }

      form.setFieldsValue({
        [deleteForm]: {
          ...formDataCurrent,
          isDelete: true,
          shown: false,
        },
      })
      let updatedList = experience?.filter(data => data?.formName !== deleteForm)
      setExperience(updatedList)
      setIsExpUpdated(true)
    }
  }
  
  const submitHandler = async (preventNavigation = false) => {
    let experience = []
    const values = await form.getFieldValue()
    
    const errorList = []
    await form
      .validateFields()
      .then()
      .catch(err => {
        errorList.push(err?.errorFields)
      })
    if (!errorList?.length) {
      Object.entries(values).forEach(([name, obj]) => {
        if (
          name.includes('experience') &&
          !name.includes('award') &&
          obj &&
          !obj?.isDelete
        ) {
          experience.push({
            ...obj,
            employee_type: '',
            workExperience: '',
            work_location: '',
            significant_outcome: '',
            awards: [],
          })
        }
      })

      // Sanitize certificate field on each experience entry before sending
      experience.forEach(data => {
        if (!data.certificate || typeof data.certificate !== 'object' || (!data.certificate.url && !data.certificate.size)) {
          delete data.certificate
        }
      })

      experience?.forEach((data, index) => {
        let awardData = []
        Object.entries(values).forEach(([name, obj]) => {
          let keyName = 'experience_' + index + '_award_'
          if (name?.includes(keyName) && obj && !obj?.isDelete) {
            // Check if obj has a certificate and it is an empty object
            if (obj?.certificate && Object.keys(obj.certificate).length === 0) {
              delete obj.certificate // Remove the certificate property from obj
            }

            awardData.push(obj)
            data.awards.push(obj)
          }
        })
      })

      if (cvDetails?.workExperience && cvDetails?.workExperience?.length) {
        studentFormData.student.cvDetails = {
          ...cvDetails,
          workExperience: experience,
        }
      }
      experience = experience.map(proj => {
        const mapped = {
          ...proj,
          temp_id: proj?.id ? proj?.temp_id : (proj?.temp_id || `temp-${uuidv4()}`),
          skill_set: proj.skill_set
            ? proj.skill_set.map(skill => ({
                id: uuidRegex.test(skill.id) ? skill.id : '',
                name: skill.name,
              }))
            : [],
        }
        // Only include certificate if it has actual data
        if (proj?.certificate && typeof proj.certificate === 'object' && (proj.certificate.url || proj.certificate.size)) {
          mapped.certificate = proj.certificate
        } else {
          delete mapped.certificate
        }
        return mapped
      });

      setSubmitLoading(true)

      let payload = {
        admin: {
          ...studentFormData?.admin,
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: studentFormData?.student,
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? studentFormData?.currentCourse
          : {},
        education: studentFormData?.education,
        resume: {
          ...studentFormData?.resume,
          workExperience: experience,
        },
        degreeStreamMap: !studentFormData?.student?.isExpCandidate
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},
        checkForApproval: true,
        checkDeleteSection: ["workExperience"],
      }
      if (payload?.currentCourse?.specialisationId === null) {
        delete payload?.currentCourse?.specialisationId
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }

      studentFormData?.education.map((item, index) => {
        if (item?.skills === null) delete payload?.education[index]?.skills
        if (item?.degreeStreamMapId === null)
          delete payload?.education[index]?.degreeStreamMapId
      })
      let response = await updateStudentData(payload)
      
      if (response?.success === true) {
        SuccessMessage('Work experience info saved successfully!')
        setSubmitLoading(false)
       
        setUpdated(true)
        if (!preventNavigation) {
          if (typeof updateCurrentState === 'function') {
            //await updateCurrentState(studentData?.id, 6)
          }
          
          if (typeof getStudentData === 'function') {
            await getStudentData(studentData?.id)
          }
          
          // Close the modal instead of navigating
          if (typeof setModalVisibleData === 'function') {
            setModalVisibleData(false)
          }
        }
      } else {
        setSubmitLoading(false)
        ErrorMessage(response?.response?.data?.message)
      }
    } else {
      const errorForms = []

      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })
      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
  }

  const handleBackClick = async () => {
    // Save current form data before navigating back
    await form.validateFields()
      .then(async () => {
        await submitHandler(true) // Pass true to prevent modal close
        setActiveTab('project')
      })
      .catch(() => {
        // If validation fails, still navigate back without saving
        setActiveTab('project')
      })
  }
  return (
    <Fragment>
      {!loading && !skillLoading ? (
        <>
          <Form
            scrollToFirstError
            onFinish={submitHandler && !updated}
            id={'experienceForm'}
            form={form}
            layout="vertical"
          >
            {!!experience?.length &&
              experience?.map((obj, idx) => {
                return (
                  <obj.component
                    key={obj?.formName}
                    form={form}
                    onRemove={experienceHandler}
                    formName={obj?.formName}
                    studentFormData={studentFormData}
                    isPresent={isPresent}
                    setIsPresent={setIsPresent}
                    setCorporateName={setCorporateName}
                    corporateName={corporateName}
                    setCorporateId={setCorporateId}
                    corporateId={corporateId}
                    getListOfSkills={getListOfSkills}
                    skillLoading={skillLoading}
                    setSkillLoading={setSkillLoading}
                    getCorporateList={getCorporateList}
                    getDesignationsList={getDesignationsList}
                    getFunctionsList={getFunctionsList}
                    getIndustryList={getIndustryList}
                    SkillsAPI={SkillsAPI}
                    allSkills={allSkills}
                    isCvTrue={isCvTrue}
                    searchAPI={searchAPI}
                    isExpUpdated={isExpUpdated}
                    shown={shown}
                  />
                )
              })}
          </Form>
          <SubHeading1>Note:</SubHeading1>
          <SubHeading1>
            Add all the details in the work experience section to increase the
            chance of recruiters considering your profile
          </SubHeading1>
          <ButtonLocal onClick={() => experienceHandler(true, false)}>
            <Control alignCenter gap="10px">
              <AdjustIcon>
                <AddIcon />
              </AdjustIcon>
              <Text>Add Work Experience</Text>
            </Control>
          </ButtonLocal>

          <Control width="100%" flexEnd gap="15px" top="35px">
            <Button.Secondary
              text="Back"
              onClick={handleBackClick}
            />
            <Button.Primary
              text="Submit"
              htmlType={'submit'}
              form={'experienceForm'}
              onClick={() => submitHandler()}
              disable={submitLoading}
            />
          </Control>
        </>
      ) : (
        <SpinWrapper center>
          <Spin />
        </SpinWrapper>
      )}
    </Fragment>
  )
}

export default WorkExperience
